import React from 'react'
import MainLogo from '../MainLogo/MainLogo'
import PageTitle from '../PageTitle/PageTitle'

import './styles.css'

import errorImg from './error.jpg'

const ErrorPage = ({title = 'Something isn’t right', message}) => (
    <div>
        <MainLogo />

        <PageTitle standalone>{title}</PageTitle>

        <p className="error-mgs">{message}</p>
        <div className="error-img">
            <img src={errorImg} alt="errorimg" />
        </div>
    </div>
)

export default ErrorPage
